import React from 'react';
import { Link } from 'react-router-dom';
import { Instagram, Linkedin, Phone } from 'lucide-react';

const FooterMinimal = () => {
  const currentYear = new Date().getFullYear();

  const socialLinks = [
    {
      name: 'Instagram',
      href: 'https://www.instagram.com/thisisaaryan__/',
      icon: Instagram
    },
    {
      name: 'LinkedIn',
      href: 'https://www.linkedin.com/in/aryan-shivhare-profile/',
      icon: Linkedin
    },
    {
      name: 'WhatsApp',
      href: 'https://wa.me/491706684547',
      icon: Phone
    }
  ];

  return (
    <footer className="bg-black border-t border-tertiary" data-testid="site-footer">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12 py-12">
        {/* Footer Nav Links */}
        <div className="flex flex-wrap items-center gap-x-8 gap-y-3 mb-8 text-sm font-sans">
          <Link to="/about" className="text-secondary hover:text-gold transition-colors" data-testid="footer-about-link">About</Link>
          <Link to="/contact" className="text-secondary hover:text-gold transition-colors" data-testid="footer-contact-link">Contact</Link>
          <Link to="/blog" className="text-secondary hover:text-gold transition-colors" data-testid="footer-blog-link">Blog</Link>
          <Link to="/privacy-policy" className="text-secondary hover:text-gold transition-colors" data-testid="footer-privacy-link">Privacy Policy</Link>
          <Link to="/cookie-policy" className="text-secondary hover:text-gold transition-colors" data-testid="footer-cookie-link">Cookie Policy</Link>
          <Link to="/terms-of-service" className="text-secondary hover:text-gold transition-colors" data-testid="footer-terms-link">Terms of Service</Link>
        </div>

        <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-6 pt-6 border-t border-tertiary">
          {/* Copyright */}
          <div className="text-sm text-tertiary font-sans">
            © {currentYear} Aryan Shivhare
          </div>

          {/* Social Links */}
          <div className="flex items-center gap-6">
            {socialLinks.map((social) => {
              const Icon = social.icon;
              return (
                <a
                  key={social.name}
                  href={social.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-secondary hover:text-gold transition-colors"
                  aria-label={social.name}
                >
                  <Icon className="w-5 h-5" strokeWidth={1.5} />
                </a>
              );
            })}
          </div>
        </div>
      </div>
    </footer>
  );
};

export default FooterMinimal;
